import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import {
	GetByIdPackingTrackingResponse,
	GetPrintTagResponse,
} from "@/main/models/response/packingTrackingHistoryResponse";
import { GetPrintPdfTagRequest } from "@/main/models/request/packingTrackingHistoryResquest";

export abstract class IPackingTrackingHistoryApi {
	abstract get(guid: string): Promise<AxiosResponse<Result<GetByIdPackingTrackingResponse[]>>>;

	abstract getPrintZplTag(packingTrackingCode: string): Promise<AxiosResponse<Result<GetPrintTagResponse>>>;

	abstract getPrintPdfTag(request: GetPrintPdfTagRequest): Promise<AxiosResponse<Result<GetPrintTagResponse>>>;
}
